import { memo } from 'react';
import { useAppSelector, useAppDispatch } from 'app/hooks';
import { resetToastAlert } from 'services/toast-alert/toastAlertSlice';
import selectToastAlert from 'services/toast-alert/toastAlertSelectors';
import { QaCommonComponent } from 'testdata/constants';
import ToastAlert from './toast-alert';

function GlobalToastAlert() {
  const toastAlert = useAppSelector(selectToastAlert);
  const dispatch = useAppDispatch();

  if (!toastAlert) {
    return null;
  }

  const doResetToastAlert = () => {
    dispatch(resetToastAlert());
  };

  return (
    <ToastAlert
      {...toastAlert}
      afterClose={doResetToastAlert}
      isGlobal
      qaSelector={QaCommonComponent.alertGlobalToast}
    />
  );
}

export default memo(GlobalToastAlert);
